import { svc_fetchAll, svc_editOne, svc_search } from "@/services";
import { svc_addStock, svc_getTotals } from "@/services/inventorystock";
import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";

const endpointBasePrefix = "inventory/catalog";

const Model = {
	namespace: "m_InventoryCatalog",
	state: {
		InventoryStock: [],
		InventoryTotals : [],
	},
	reducers: {
		updateModelState(state, { payload: { response } }) {
			return { ...state, InventoryStock: response };
		},
		updateTotalState(state, { payload: { response } }){
			return { ...state, InventoryTotals: response};
		}
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			// The variable name response will be passed on to payload later
			const response = yield call(svc_fetchAll, `${endpointBasePrefix}/brand/${payload.category?.brand_id}`);
			// if response was not a success code, exit and don't update anything.
			if (!showServerResponse(response, false)) return;
			_.forEach(response, function (row) {
				row.key = row.id;
				row.name = `${row.sku_code} - ${row.sku_desc}`;
			});
			yield put({
				type: "updateModelState",
				payload: { response },
			})

			return response
		},
	},
	subscriptions: {
		// setup({ dispatch, history }) {
		// 	return history.listen(({ pathname, query }) => {
		// 		if (pathname === "/menu" || pathname === "/brands") {
		// 			dispatch({ type: "fetchAll", payload: query });
		// 		}
		// 	});
		// },
	},
};

export default Model;
